import { TranslateFunction } from "@fkui/logic";
import { RootState } from "@/store/types";
import { VISA_BARA_TEXTNYCKEL } from "@/constants";

export interface FormatData {
    textnyckel: string;
    value: string | null;
    isEnabled?: boolean;
}

export interface FormatServiceInterface {
    getValue(formatData: FormatData, isEnabled: boolean): string | null;
    filterValues(values: Array<FormatData>): Array<string | null>;
    getContent(state: RootState): string;
    getFormData(state: RootState): Array<FormatData>;
    getHeader(): string;
    removeIllegalCharacters(value: string): string;
}

export abstract class FormatService implements FormatServiceInterface {
    public $t!: TranslateFunction;

    public constructor(translateFunction: TranslateFunction) {
        this.$t = translateFunction;
    }

    public getValue({
        textnyckel,
        value,
        isEnabled = true,
    }: FormatData): string | null {
        if (value === VISA_BARA_TEXTNYCKEL && isEnabled) {
            return `\n@s@${this.$t(textnyckel)}@!s@`;
        }
        return value && isEnabled
            ? `\n@s@${this.$t(textnyckel)}@!s@\n${value}`
            : null;
    }

    public filterValues(values: Array<FormatData>): Array<string | null> {
        return values
            .filter((x) => this.getValue(x) !== null)
            .map((x) => this.getValue(x));
    }

    public getContent(state: RootState): string {
        return this.getHeader().concat(
            this.filterValues(this.getFormData(state)).join("\n"),
        );
    }

    public removeIllegalCharacters(value: string): string {
        // Remove characters that will not pass whitelist in backend
        return value.replace(/([^a-zA-Z0-9 .,\-()\r\n?+=!:@*\xC0-\xFF]+)/g, "");
    }
    public abstract getHeader(): string;

    public abstract getFormData(state: RootState): Array<FormatData>;
}
